module.exports = __webpack_public_path__ + "img/logo-manage-light.d7be5840.png";